import React from "react";
import style from "./style.module.scss";
import dynamic from "next/dynamic";
const Card = dynamic(() => import("./Card"), { ssr: true });
const BuildSection = dynamic(() => import("../BuildSection"), { ssr: true });
import Image from "next/image";

const Testimonial = dynamic(() => import("../testimonial/Testimonial"));

interface ITestimonial {
  testimonial: any;
  bookConsultant: any;
  caseStudies: any;
  loading: boolean;
}
const TechCard: React.FC<ITestimonial> = ({ testimonial, bookConsultant, caseStudies, loading }) => {
  let testimonialCounter = 0;
  let bookConsultantCounter = 0;
  const totalTestimonials = testimonial?.testimonials?.data?.length || 0;
  const totalBookSections = bookConsultant?.["book-consultations"]?.length || 0;

  return (
    <section
      id="case-studies-container"
      className={`${style["tech-card-section"]} min-h-[40vh]`}
    >
      <div className="container">
        <div className="grid md:grid-cols-2 grid-cols-1 lg:gap-[80px_30px] md:gap-[40px_30px] gap-[48px]">
          {caseStudies?.map((study: any, index: number) => {

            //Testimonial logic
            let showTestimonial = false;
            let currentTestimonialIndex = 0;

            if (
              ((index + 1) % 6 === 3 && totalTestimonials > 0) ||
              caseStudies.length < 3
            ) {
              showTestimonial = true;
              currentTestimonialIndex = testimonialCounter % totalTestimonials;
              testimonialCounter++;
            }

            //Book Consultant logic
            let showBookConsultant = false;
            let currentBookConsultantIndex = 0;
            if ((index + 1) % 6 === 0 && totalBookSections > 0) {
              showBookConsultant = true;
              currentBookConsultantIndex =
                bookConsultantCounter % totalBookSections;
              bookConsultantCounter++;
            }

            return (
              <React.Fragment key={index}>
                <Card
                  item={study}
                  className={index % 3 === 0 ? "md:col-span-2 col-span-1" : ""}
                />
                {(index + 1) % 3 === 0 && (
                  <div className="md:col-span-2 col-span-1">
                    {showTestimonial && (
                      <Testimonial
                        block={testimonial}
                        testimonialIndex={currentTestimonialIndex}
                      />
                    )}
                    {showBookConsultant && (
                      <BuildSection
                        block={
                          bookConsultant["book-consultations"][
                          currentBookConsultantIndex
                          ]
                        }
                      />
                    )}
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
        {/* Loading Indicator */}
        {loading && (
          <Image
            src="/images/bouncing-squares.svg"
            alt="loader"
            width={100}
            height={100}
            className="mx-auto"
          />
        )}

        {/* Empty State Message */}
        {!loading && caseStudies?.length === 0 && (
          <div className="flex items-center justify-center py-20 w-full">
            <p className="text-subtitle-1 font-semibold text-primary-text">
              No results found
            </p>
          </div>
        )}
      </div>
    </section>
  );
}

export default TechCard;
